import { isString } from './getType';

// 字符串转对象处理
const transformToObj = (data: string, con) => {
  let res = transformToArray(data);
  res = res.map((k) => {
    const val = con.filter((i: any) => {
      return i.value === k;
    })[0];
    return val;
  });
  return res;
};

// 数组转字符串
const transformToString = (data: any[], symbol = ',') => {
  if (Array.isArray(data)) {
    if (data.length > 1) return data?.filter((res) => res).join(symbol);
    else return data[0];
  } else {
    return data;
  }
};

// 字符串转数组
const transformToArray = (data: string, symbol = ',') => {
  if (typeof data !== 'string') return data;
  return data ? data?.split(symbol) : [];
};

// 字符串转换成可展示的字符串
const transformToShow = (con, value) => {
  const res = transformToObj(value, con);
  const val: any = res?.map((i: any) => {
    return i ? i.label : i;
  });
  return transformToString(val);
};

// 换行处理 只去除前后空格，不去除中段空格
const breakLine = (value) =>
  isString(value)
    ? value
        .split(/[\n\r]+/)
        ?.map((e: string) => e?.substring(Math.max(e?.search(/\S/), 0), e?.search(/\S\s*$/) + 1))
        ?.filter((e) => e)
    : [];

// 有差异的数据返回对应样式，默认红色
const diffStyle = (v1: number, v2: number, style = null) => {
  return v1 !== v2 ? style || { color: 'red' } : {};
};

/**
 * 处理长宽高展示
 */
const dealSize = (length: number, width: number, height: number, symbol = '*') => {
  const l = String(length || '') ? `${length} ${symbol}` : symbol;
  const w = String(width || '') ? ` ${width} ${symbol} ` : symbol;
  const h = String(height || '') || '';
  return `${l}${w}${h}`;
};

export { transformToObj, transformToString, transformToArray, transformToShow, breakLine, diffStyle, dealSize };
